import { AboutUsTemplate, MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer, HeroBanner } from "@/design-system/Organisms";
import { aboutUsHeroData } from "@/design-system/Organisms/HeroBanner/heroBanner.data";

const AboutUsPage = () => (
  <MainLayout
    header={<Header {...headerConfig} />}
    sidebar={null}
    className=""
    footer={<Footer />}
    topBanner={<HeroBanner {...aboutUsHeroData} />}
  >
    <AboutUsTemplate />
  </MainLayout>
);

export default AboutUsPage;
